import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Monitor, HeartHandshake, Trees, Truck, Sparkles, Building2 } from "lucide-react";

// Single source of truth for the 8-item category list + icons shown on
// every service category page's sidebar (Home/Technical/Caretaker/Outdoor/
// Transport/Special/Corporate Services + All Categories) — previously each
// page kept its own near-duplicate list, several with wrong paths (missing
// the /services/ prefix, pointing at routes that don't exist) and no icons.
export const SERVICE_CATEGORIES = [
  { label: "All Categories",     path: "/services/all-services",          icon: Home,           color: "#6b7280" },
  { label: "Home Services",      path: "/services/instant-home-services", icon: Home,           color: "#4f46e5" },
  { label: "Technical Services", path: "/services/technical-services",    icon: Monitor,        color: "#6366f1" },
  { label: "Caretaker Services", path: "/services/caretaker-services",    icon: HeartHandshake, color: "#a855f7" },
  { label: "Outdoor Services",   path: "/services/outdoor-services",      icon: Trees,          color: "#65a30d" },
  { label: "Transport Services", path: "/services/transport-services",    icon: Truck,          color: "#f59e0b" },
  { label: "Special Services",   path: "/services/special-services",      icon: Sparkles,       color: "#c026d3" },
  { label: "Corporate Services", path: "/services/corporate-services",    icon: Building2,      color: "#0ea5e9" },
];

const CategorySidebar = () => {
  const location = useLocation();

  return (
    <div style={S.card}>
      {SERVICE_CATEGORIES.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;

        return (
          <Link key={item.path} to={item.path} style={S.link}>
            <div style={{ ...S.item, ...(isActive ? S.itemActive : {}) }}>
              <div style={{ ...S.iconWrap, background: isActive ? "#eef2ff" : "transparent" }}>
                <Icon size={15} color={item.color} />
              </div>
              <span style={{ ...S.text, color: isActive ? "#4f46e5" : "#374151", fontWeight: isActive ? 700 : 500 }}>
                {item.label}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

const S = {
  card: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "8px" },
  link: { display: "block", textDecoration: "none" },
  item: { width: "100%", display: "flex", alignItems: "center", gap: "9px", borderRadius: "10px", padding: "8px 9px", marginBottom: "2px" },
  itemActive: { background: "#f5f7ff" },
  iconWrap: { width: "22px", height: "22px", borderRadius: "7px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  text: { fontSize: "13px" },
};

export default CategorySidebar;
